import { render, staticRenderFns } from "./secondfifth.vue?vue&type=template&id=0bfa0dfa&"
import script from "./secondfifth.vue?vue&type=script&lang=js&"
export * from "./secondfifth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bfa0dfa')) {
      api.createRecord('0bfa0dfa', component.options)
    } else {
      api.reload('0bfa0dfa', component.options)
    }
    module.hot.accept("./secondfifth.vue?vue&type=template&id=0bfa0dfa&", function () {
      api.rerender('0bfa0dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/second/secondfifth.vue"
export default component.exports